import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Globe, Plane, ArrowLeft, Check } from 'lucide-react';
import { API } from '../../shared/config';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const plusJours = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };

export const AccesPaysRefuse = ({ refus, onBack }) => {
  const [motif, setMotif] = useState('');
  const [fin, setFin] = useState(plusJours(14));
  const [busy, setBusy] = useState(false);
  const [envoyee, setEnvoyee] = useState(null);

  const demander = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/securite/demande-acces-pays`, { demande_token: refus.demande_token, motif, fin });
      setEnvoyee(r.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Envoi impossible');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5" data-testid="acces-pays-refuse">
      <div className="flex flex-col items-center text-center gap-2">
        <span className="w-12 h-12 rounded-2xl bg-red-50 flex items-center justify-center">
          <Globe className="w-6 h-6 text-red-600" />
        </span>
        <h3 className="text-lg font-bold text-[#0A2350]">Connexion refusée</h3>
        <p className="text-sm text-gray-600" data-testid="acces-pays-message">
          Vous tentez de vous connecter depuis <b>{refus.pays}</b>. Votre compte n'est autorisé qu'en{' '}
          <b>{(refus.zone || []).map(z => z.nom).join(', ')}</b>.
        </p>
      </div>

      {envoyee ? (
        <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-800 flex gap-2" data-testid="acces-pays-demande-ok">
          <Check className="h-5 w-5 shrink-0" />
          <span>Demande envoyée à la direction pour <b>{envoyee.pays}</b> jusqu'au <b>{new Date(envoyee.fin + 'T00:00:00').toLocaleDateString('fr-FR')}</b>. Vous recevrez une notification dès qu'elle sera traitée.</span>
        </div>
      ) : refus.demande_token ? (
        <form onSubmit={demander} className="space-y-3 rounded-xl border border-gray-200 p-4" data-testid="acces-pays-demande-form">
          <p className="text-sm font-semibold text-gray-800 inline-flex items-center gap-1.5"><Plane className="h-4 w-4 text-[#1173D4]" /> Demander une autorisation temporaire</p>
          <div className="space-y-1">
            <Label htmlFor="fin-aut" className="text-xs text-gray-600">Jusqu'au</Label>
            <Input id="fin-aut" type="date" value={fin} min={plusJours(0)} onChange={e => setFin(e.target.value)} required data-testid="acces-pays-fin-input" />
          </div>
          <div className="space-y-1">
            <Label htmlFor="motif-aut" className="text-xs text-gray-600">Motif</Label>
            <Input id="motif-aut" value={motif} onChange={e => setMotif(e.target.value)} placeholder="Vacances, congrès, télétravail…" data-testid="acces-pays-motif-input" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-[#1173D4] hover:bg-[#0A2350] text-white" data-testid="acces-pays-demander-btn">
            {busy ? 'Envoi…' : 'Envoyer la demande à la direction'}
          </Button>
        </form>
      ) : (
        <p className="text-xs text-gray-500 text-center">Pays indéterminé : contactez votre direction.</p>
      )}

      <Button type="button" variant="ghost" onClick={onBack} className="w-full" data-testid="acces-pays-retour-btn">
        <ArrowLeft className="w-4 h-4 mr-2" /> Retour à la connexion
      </Button>
    </div>
  );
};
